import React, { useContext } from 'react';
import { Attachment, logChatPromiseExecution, UserResponse } from 'stream-chat';
import {
  MessageList,
  MessageInput,
  Window,
  StreamMessage,
  useChannelActionContext,
  Thread,
  TypingIndicator,
} from 'stream-chat-react';


import { GiphyContext, StreamChatGenerics } from '../../chat';
import MessagingChannelHeader from '../MessagingChannelHeader/MessagingChannelHeader';
import MessagingInput from '../MessagingInput/MessagingInput';

export type ChannelInnerProps = {
  toggleMobile: () => void;
  theme: string;
};

export const ChannelInner: React.FC<ChannelInnerProps> = (props) => {
  const { theme, toggleMobile } = props;
  const { giphyState, setGiphyState } = useContext(GiphyContext);

  const { sendMessage } = useChannelActionContext<StreamChatGenerics>();

  const overrideSubmitHandler = (message: {
    attachments: Attachment[];
    mentioned_users: UserResponse[];
    text: string;
    parent?: StreamMessage;
  }) => {
    let updatedMessage;

    if (message.attachments?.length && message.text?.startsWith('/giphy')) {
      const updatedText = message.text.replace('/giphy', '');
      updatedMessage = { ...message, text: updatedText };
    }

    if (giphyState) {
      const updatedText = `/giphy ${message.text}`;
      updatedMessage = { ...message, text: updatedText };
    }

    if (sendMessage) {
      const newMessage = updatedMessage || message;
      const parentMessage = newMessage.parent;

      const messageToSend = {
        ...newMessage,
        parent: parentMessage
          ? {
              ...parentMessage,
              created_at: parentMessage.created_at?.toString(),
              pinned_at: parentMessage.pinned_at?.toString(),
              updated_at: parentMessage.updated_at?.toString(),
            }
          : undefined,
      };
      //@ts-ignore
      const sendMessagePromise = sendMessage(messageToSend);
      logChatPromiseExecution(sendMessagePromise, 'send message');
    }

    setGiphyState(false);
  };

  // const actions = ['delete', 'edit', 'flag', 'mute', 'react', 'reply'];

  return (
    <>
      <Window >
        <MessagingChannelHeader theme={theme} toggleMobile={toggleMobile} />
        <MessageList 
        
        messageActions={['delete', 'quote', 'react']} 
        />
        {/* <TypingIndicator /> */}
        <MessageInput focus />
      </Window>




      {/* <Thread Input={MessagingInput} /> */}
    </>
  );
};
